import './TypeBadge.scss';

import { SuccessBadge, WarningBadge, Badge } from '@tmapy/style-guide';

import { EDAS_TYPE } from '../constants';

type TypeBadgeProps = {
  type: EDAS_TYPE;
  label: string;
};

export const TypeBadge: React.FC<TypeBadgeProps> = ({ type, label }) => {
  switch (type) {
    case EDAS_TYPE.app: {
      return <WarningBadge>{label}</WarningBadge>;
    }
    case EDAS_TYPE.dataset: {
      return <SuccessBadge>{label}</SuccessBadge>;
    }
    case EDAS_TYPE.mapApp: {
      return <Badge unsafeClassName='e-typeBadge-map'>{label}</Badge>;
    }
    default: {
      console.error('TypeBadge: Unknown type', type);
      return type;
    }
  }
};
